import { useEffect, useState } from "react";

export function useCameraCapability() {
  const [cameraAvailable, setCameraAvailable] = useState(true);
  const [cameraCapabilityChecked, setCameraCapabilityChecked] = useState(false);

  useEffect(() => {
    let disposed = false;

    const updateCameraCapability = async () => {
      try {
        if (typeof navigator === "undefined" || !navigator.mediaDevices?.enumerateDevices) {
          if (!disposed) {
            setCameraAvailable(false);
            setCameraCapabilityChecked(true);
          }
          return;
        }

        const devices = await navigator.mediaDevices.enumerateDevices();
        const hasVideoInput = devices.some((d) => d.kind === "videoinput");
        if (!disposed) {
          setCameraAvailable(hasVideoInput);
          setCameraCapabilityChecked(true);
        }
      } catch {
        if (!disposed) {
          setCameraAvailable(false);
          setCameraCapabilityChecked(true);
        }
      }
    };

    updateCameraCapability();
    const mediaDevices = typeof navigator !== "undefined" ? navigator.mediaDevices : undefined;
    const onDeviceChange = () => {
      updateCameraCapability();
    };
    mediaDevices?.addEventListener?.("devicechange", onDeviceChange);

    return () => {
      disposed = true;
      mediaDevices?.removeEventListener?.("devicechange", onDeviceChange);
    };
  }, []);

  return {
    cameraAvailable,
    setCameraAvailable,
    cameraCapabilityChecked,
    setCameraCapabilityChecked,
  };
}
